import React, { useEffect, useState } from "react";
import {
  FaArrowUp,
  FaInstagram,
  FaLinkedin,
  FaXTwitter,
  FaRobot,
  FaXmark
} from "react-icons/fa6";
import "./FloatingButtons.css";
import founderImg from "../assets/founder.png";

const autoReplies = [
  {
    q: "What is CM Group of Companies?",
    a: "CM Group of Companies is an integrated organization established in 2019, specializing in strategic land development and sustainable energy solutions."
  },
  {
    q: "When was CM Group of Companies founded?",
    a: "CM Group of Companies was founded in 2019 with a vision to create impactful and sustainable infrastructure solutions."
  },
  {
    q: "What services does CM Group of Companies provide?",
    a: "We provide strategic land development, renewable energy infrastructure, and integrated solutions connecting real estate and clean power."
  },
  {
    q: "What makes CM Group of Companies different?",
    a: "We operate as a strategic connector rather than siloed divisions, delivering end-to-end solutions from land acquisition to power generation."
  },
  {
    q: "What is meant by integrated success?",
    a: "Integrated success means combining land, infrastructure, and energy planning to ensure long-term sustainability and project viability."
  },
  {
    q: "How much land has CM Group of Companies developed?",
    a: "We have successfully delivered over 600 acres of strategic land for critical development and investment opportunities."
  },
  {
    q: "What renewable energy projects has CM Group completed?",
    a: "Our landmark achievement includes the successful installation of a 150 MW Solar Power Plant."
  },
  {
    q: "Do you focus on sustainable power generation?",
    a: "Yes, sustainability is at the core of our operations, with a strong focus on renewable and environmentally responsible energy solutions."
  },
  {
    q: "Do you handle large-scale infrastructure projects?",
    a: "Yes, we specialize in large-scale infrastructure and renewable energy projects across India."
  },
  {
    q: "What industries do you support?",
    a: "We support renewable energy developers, real estate investors, infrastructure partners, and industrial projects."
  },
  {
    q: "Where is CM Group of Companies located?",
    a: "Our office is located at Moongiltholuvu, Udumalpet – 642202."
  },
  {
    q: "How can I contact CM Group of Companies?",
    a: "You can contact us by phone at +91 99446 62747 or via email at cmpranesh@cmgroupofcompanies.com."
  },
  {
    q: "Do you provide land for solar power projects?",
    a: "Yes, we specialize in identifying and delivering strategic land suitable for solar and other renewable energy projects."
  },
  {
    q: "Is CM Group involved in environmental responsibility?",
    a: "Absolutely. Environmental responsibility is embedded in our planning, development, and power generation initiatives."
  },
  {
    q: "Do you work across India?",
    a: "Yes, we undertake projects across India, supporting national growth in sustainable infrastructure."
  },
  {
    q: "What is CM Group’s long-term vision?",
    a: "Our vision is to build future-ready infrastructure by integrating land development with sustainable energy solutions."
  }
];


export default function FloatingButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hello 👋 How can I help you today?" }
  ]);
  const [replyIndex, setReplyIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleUserClick = () => {
    const qa = autoReplies[replyIndex];

    setMessages(prev => [
      ...prev,
      { from: "user", text: qa.q }
    ]);

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        { from: "bot", text: qa.a }
      ]);
    }, 600);

    setReplyIndex((prev) => (prev + 1) % autoReplies.length);
  };

  return (
    <>
      {/* FLOATING BUTTONS */}
      <div className="floating-btn-wrapper">
<a
  href="https://wa.me/919944662747"
  target="_blank"
  rel="noopener noreferrer"
  className="floating-btn whatsapp-btn"
>
  <img
    src={founderImg}
    alt="Founder"
    width="40"
    height="40"
  />
</a>

        <a
          href="https://instagram.com/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn insta-btn"
        >
          <FaInstagram />
        </a>

        <a
          href="https://www.linkedin.com/in/cm-group-of-companies-644059416/"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn linkedin-btn"
        >
          <FaLinkedin />
        </a>

        <a
          href="https://twitter.com/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn twitter-btn"
        >
          <FaXTwitter />
        </a>

        {/* AI CHAT BUTTON */}
        <button
          className="floating-btn ai-btn"
          onClick={() => setShowChat(true)}
        >
          <FaRobot />
        </button>

        {showScrollTop && (
          <button
            className="floating-btn scrolltop-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <FaArrowUp />
          </button>
        )}
      </div>

      {/* CHAT POPUP */}
      {showChat && (
        <div className="ai-chat-box">
          <div className="ai-chat-header">
            <span>AI Assistant</span>
            <FaXmark onClick={() => setShowChat(false)} />
          </div>

          <div className="ai-chat-body">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`chat-message ${msg.from}`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <div className="ai-chat-footer">
            <button onClick={handleUserClick}>
              Ask a question
            </button>
          </div>
        </div>
      )}
    </>
  );
}
